// extracted by mini-css-extract-plugin
module.exports = {"feedbackContainer":"Feedback_feedbackContainer__1kBI1","meme":"Feedback_meme__Fv4eG","user":"Feedback_user__TF9kC","buttonPlayAgain":"Feedback_buttonPlayAgain__1p0p7"};